import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";



const Retailcs1 = () => {
    const isMobile = useMediaQuery("(max-width: 900px)");
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      <Box sx={{ position: "relative", overflow: "hidden" }} >
        {/* Background Half-Moon Shape */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: isMobile ? "100%" : "70%",
            height: "100%",
            background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
            borderTopLeftRadius: isMobile ? "100% 40%" : "100% 100%",
            borderBottomLeftRadius: isMobile ? "100% 40%" : "100% 100%",
            zIndex: 0,
          }}
        />
      
        {/* Actual Content (your original layout) */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            width: isMobile ? "100%" : "90%",
            padding: isMobile ? "30px 15px" : "50px 50px",
            gap: "50px",
            boxSizing: "border-box",
            margin: "0 auto",
            minHeight: isMobile ? "auto" : "100vh",
            paddingTop: isMobile ? "120px" : "0px",
            marginBottom: isMobile ? "100px" : "-50px",
            zIndex: 1,
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              flex: 1,
              textAlign: isMobile ? "center" : "left",
              margin: "0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: isMobile ? "50px" : "60px",
                marginTop: isMobile ? "100px":"-150px",
              }}
              mb={8}
            >
            An IT Foundation to Build On
            </Typography>
      
            <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#333" }}>
            KB Home needed to boost operational efficiency, flexibility and agility so it could continuously respond to customer demand.</Typography>
            <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#333" }}>
            KB Home partners with Tech Informatic Solutions to manage IT infrastructure services—covering data center and help desk operations, security, servers, networking and messaging—so staff can focus on the core business.</Typography>
            
          </Box>
      
          {/* Right Image */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0px",
              marginTop: isMobile ? "50px" : "0px",
            }}
          >
            <img
              src="/image/retailcs1.jpg"
              alt="About Us"
              style={{
                width: isMobile ? "90%" : "100%",
                maxHeight: "100%",
                objectFit: "cover",
                borderRadius: "10px",
                boxShadow: `
                  0px 12px 25px rgba(0, 0, 0, 0.6),  
                  inset 0px 10px 20px rgba(255, 255, 255, 0.15),
                  inset 0px -10px 30px rgba(0, 0, 0, 0.7),
                  inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
                  inset -10px 0px 20px rgba(255, 255, 255, 0.2)
                `,
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        KB Home needed to boost operational efficiency, flexibility and agility so it could continuously respond to customer demand.</Typography>
       



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={2}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Improves customer offerings",
                "Simplifies innovation and reduces risk",
                "Protects business from cybercrime",
                
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Boosts agility in meeting dynamic requirements",
                "Increases efficiency, insights and cost savings",
                
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>







      <Container sx={{ py: 10 }}>
      
       
        <Typography  variant="h4" fontWeight="bold" mb={3}>
         Solution
        </Typography>
        
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        KB Home partners with Tech Informatic Solutions to manage IT infrastructure services—covering data center and help desk operations, security, servers, networking and messaging—so staff can focus on the core business.</Typography>
        

</Container>



<Footer/>
    </Box>


  );
};

export default Retailcs1;
